export default {
  moduleEl: document.querySelector('.module-impressions'),
  init() {
    if (!this.moduleEl) {
      return;
    }

    // all of this seems a bit weird and is solely to circumvent cachify for the time thing
    const href = window.location.href + '?disablecachify=true';

    fetch(href)
      .then((response) => response.text())
      .then((html) => {
        const original = this.moduleEl.querySelector('.active-tile.activity');
        const page = document.createElement('div');
        page.innerHTML = html;
        const replacement = page.querySelector('.active-tile.activity');
        original.replaceWith(replacement);
        page.remove();
      });
  },
};
